// Central configuration for section IDs used in navigation
export const SECTIONS = {
  SERVICE: 'service-info',
  ANTHOLOGY: 'anthology',
  FOOTER: 'footer'
};
